export type PlanKey = "starter" | "challenger" | "master";

export interface PlanItem {
  key: PlanKey;
  name: string;
  price: number;
  tag?: string;
  features: { text: string; included: boolean; info?: boolean }[];
}

export const planKeyToName: Record<PlanKey, string> = {
  starter: "스타터",
  challenger: "챌린저",
  master: "마스터",
};

// pricingModel "e" / "h" / "i" / "j" / "f" 는 단일 "맞춤 플랜" 카드(challenger 매핑)를 노출하며,
// 각 모델별로 challenger 가격을 오버라이드한다.
export const SINGLE_PLAN_PRICES: Record<string, number> = {
  e: 395000,
  h: 595000,
  i: 695000,
  j: 425000,
  f: 495000,
};

export const isSinglePlanPricingModel = (model: string | undefined): boolean =>
  model !== undefined && model in SINGLE_PLAN_PRICES;

export const getSinglePlanPrice = (
  model: string | undefined
): number | undefined =>
  isSinglePlanPricingModel(model)
    ? SINGLE_PLAN_PRICES[model as string]
    : undefined;
